var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_12091_116836)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92651 11.5827C3.92651 10.7998 4.56115 10.1652 5.34401 10.1652C6.12687 10.1652 6.7615 10.7998 6.7615 11.5827C6.7615 12.3656 6.12687 13.0002 5.34401 13.0002C4.56115 13.0002 3.92651 12.3656 3.92651 11.5827Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17119 6.76323C8.38833 6.76323 7.75369 7.39786 7.75369 8.18072V14.4177C7.75369 15.2006 8.38833 15.8352 9.17119 15.8352C9.95405 15.8352 10.5887 15.2006 10.5887 14.4177V8.18072C10.5887 7.39786 9.95405 6.76323 9.17119 6.76323Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4084 11.2992C15.4084 10.5163 16.043 9.88168 16.8259 9.88168C17.6087 9.88168 18.2433 10.5163 18.2433 11.2992V17.5361C18.2433 18.319 17.6087 18.9536 16.8259 18.9536C16.043 18.9536 15.4084 18.319 15.4084 17.5361V11.2992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9984 3.92822C12.2155 3.92822 11.5809 4.56286 11.5809 5.34572V20.6547C11.5809 21.4375 12.2155 22.0721 12.9984 22.0721C13.7812 22.0721 14.4159 21.4375 14.4159 20.6547V5.34572C14.4159 4.56286 13.7812 3.92822 12.9984 3.92822Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2356 14.4177C19.2356 13.6348 19.8702 13.0002 20.6531 13.0002C21.4359 13.0002 22.0706 13.6348 22.0706 14.4177C22.0706 15.2006 21.4359 15.8352 20.6531 15.8352C19.8702 15.8352 19.2356 15.2006 19.2356 14.4177Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12091_116836",
    x1: 1,
    y1: 1,
    x2: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E3599A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF54A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseAi);
export default __webpack_public_path__ + "static/media/pulse-ai.eba4b4ac731eebef5fd7ad6e758f3d84.svg";
export { ForwardRef as ReactComponent };